// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import X from "@insite/mobius/Icons/X";
import { filterListStyles } from "@steiner/Overrides/Widgets/ProductList/ProductListFilterList";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

filterListStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

filterListStyles.filterTagsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 8px 4px;
    `,
};

filterListStyles.clearAllLink = {
    icon: {
        iconProps: {
            src: X,
            size: 12,
        },
        position: "left",
    },
    typographyProps: {
        size: fontConfig.fontSize.xSmall,
        lineHeight: fontConfig.lineHeight.xSmall,
    },
    css: css`
        margin: 0;
    `,
};

filterListStyles.filterTag = {
    mergeCss: true,
    css: css`
        margin: 0;
    `,
};

filterListStyles.filterText = {
    variant: "h5",
    color: "common.white",
    css: css`
        background-color: ${color("common.ui8")};
        padding: 8px;
        width: 100%;
    `,
};
